/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { CallerType } from '../../models/caller-type';
import { ClientId } from '../../models/client-id';

export interface GetSeatmapSvg$Params {
  cartId?: string;
  orderId?: string;
  flightId: string;
  token?: string;
  currencyCode?: string;
  departureDateTime?: string;
  version?: number;

/**
 * Locale should be provided in 'ISO language code' or 'ISO language code'_'ISO country code' format. E.g. 'en' or 'en_US'. CoreMedia locale is supported but deprecated
 */
  locale?: string;
  rotation?: string;
  theme?: string;
  Caller?: CallerType;

/**
 * Session ID in UUID format used to aggregate all the calls for a single customer
 */
  'X-Session-Id'?: string;

/**
 * Client ID representing the caller system
 */
  'X-Client-Id'?: ClientId;

/**
 * W3C Trace Context traceparent header used for distributed tracing
 */
  traceparent?: string;

/**
 * W3C Trace Context tracestate header used for distributed tracing
 */
  tracestate?: string;

/**
 * W3C Baggage header used to propagate contextual key-value pairs
 */
  baggage?: string;
}

export function getSeatmapSvg(http: HttpClient, rootUrl: string, params: GetSeatmapSvg$Params, context?: HttpContext): Observable<DapiHttpResponse<string>> {
  const rb = new DapiRequestBuilder(rootUrl, getSeatmapSvg.PATH, 'get');

  if (params) {
    rb.query('cartId', params.cartId, {});
    rb.query('orderId', params.orderId, {});
    rb.query('flightId', params.flightId, {});
    rb.query('token', params.token, {});
    rb.query('currencyCode', params.currencyCode, {});
    rb.query('departureDateTime', params.departureDateTime, {});
    rb.query('version', params.version, {});
    rb.query('locale', params.locale, {});
    rb.query('rotation', params.rotation, {});
    rb.query('theme', params.theme, {});
    rb.header('Caller', params.Caller, {});
    rb.header('X-Session-Id', params['X-Session-Id'], {});
    rb.header('X-Client-Id', params['X-Client-Id'], {});
    rb.header('traceparent', params.traceparent, {});
    rb.header('tracestate', params.tracestate, {});
    rb.header('baggage', params.baggage, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'image/svg+xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as DapiHttpResponse<string>;
    }),
    catchErrorAsJson()
  );
}

getSeatmapSvg.PATH = '/api/seatmap/svg';
